import React from "react";
import pointsIcon from "../../img/points.png";
import timerIcon from "../../img/timer.png";
import { formatMmSs } from "../../utils/yogaPoints";
import "./gameHud.css";

/**
 * Travel India HUD: timer pinned left, points + Rules button grouped on the
 * right. No progress bar (intentionally omitted vs. the yoga HUD).
 * Colors come from the admin theme (button background / text).
 */
export default function GameHud({ timeSec, points, onRules, buttonBg, buttonText }) {
  const pillStyle = {
    ...(buttonBg && { backgroundColor: buttonBg }),
    ...(buttonText && { color: buttonText }),
  };

  return (
    <div className="game-hud">
      <div className="game-hud-stat game-hud-timer" style={pillStyle}>
        <img src={timerIcon} alt="" className="game-hud-icon" />
        <span className="game-hud-value">{formatMmSs(timeSec)}</span>
      </div>

      <div className="game-hud-right">
        <div className="game-hud-stat game-hud-points" style={pillStyle}>
          <img src={pointsIcon} alt="" className="game-hud-icon" />
          <span className="game-hud-value">Points: {points}</span>
        </div>
        <button type="button" className="game-hud-rules" onClick={onRules} style={pillStyle}>
          How to play
        </button>
      </div>
    </div>
  );
}
